import { CLY_E_PV } from './const'
import { getAllUrlParameters } from './utils'

const currentCountlyPageviewSrc = document.currentScript?.src
const currentCountlyPageviewparams = getAllUrlParameters(currentCountlyPageviewSrc)
window.currentCountlyPageHistory = []

function trackRoute(route: string) {
  if (!currentCountlyPageviewSrc) {
    console.error('无法获取currentScript')
    return
  }

  window.currentCountlyPageSrc = route
  const preRoute = window.currentCountlyPageHistory[window.currentCountlyPageHistory.length - 1]

  const { appKey, name, pageviewWaitUserDetails, debug, ...restParams } = currentCountlyPageviewparams

  if (window[name || 'Countly']) {
    // 循环检查window.Countly.isUserDetailInit是否为true
    const toTrack = () => {
      debug && console.log('pv上报[route, preRoute, isTrackInited]', route, preRoute, window.Countly.isTrackInited)
      window[name || 'Countly'].add_business_event({
        key: CLY_E_PV,
        segmentation: {
          href: route,
          fromHref: preRoute || '',
          ...restParams,
        },
      })
    }
    const waitUserDetailsTrack = () => {
      debug && console.log('用户信息是否初始化 isTrackInited', window.Countly.isTrackInited)
      if (!window.Countly.isTrackInited) {
        return setTimeout(waitUserDetailsTrack, 100)
      }
      toTrack()
    }
    if (pageviewWaitUserDetails) {
      waitUserDetailsTrack()
    } else {
      toTrack()
    }
  }
  window.currentCountlyPageHistory.push(route)
}

function getRoute() {
  return window.location.pathname + window.location.hash
}

interface RouteTracker {
  lastRoute: string
  debounceTimer: number | null
  isProcessing: boolean
}

const routeTracker: RouteTracker = {
  lastRoute: '',
  debounceTimer: null,
  isProcessing: false
}

function optimizedTrackRoute(newRoute: string, source: string) {
  // 清除之前的防抖定时器
  if (routeTracker.debounceTimer) {
    clearTimeout(routeTracker.debounceTimer)
    routeTracker.debounceTimer = null
  }
  
  // 路由未变化时跳过
  if (routeTracker.lastRoute === newRoute) {
    return
  }
  
  // 正在处理时跳过
  if (routeTracker.isProcessing) {
    return
  }
  
  routeTracker.debounceTimer = setTimeout(() => {
    routeTracker.isProcessing = true
    
    try {
      routeTracker.lastRoute = newRoute
      trackRoute(newRoute)
    } catch (error) {
      console.error('Route tracking error:', error)
    } finally {
      routeTracker.isProcessing = false
      routeTracker.debounceTimer = null
    }
  }, 16) // 约一帧的时间，减少延迟
}

export function initPv() {
  if (window.routeTrackerInitialized) return
  window.routeTrackerInitialized = true

  const originalPushState = history.pushState
  const originalReplaceState = history.replaceState

  // 重写 history 方法
  history.pushState = function (...args) {
    originalPushState.apply(this, args)
    optimizedTrackRoute(getRoute(), 'pushState')
  }

  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args)
    optimizedTrackRoute(getRoute(), 'replaceState')
  }

  // 事件监听器
  window.addEventListener('popstate', () => {
    optimizedTrackRoute(getRoute(), 'popstate')
  })

  window.addEventListener('hashchange', () => {
    optimizedTrackRoute(getRoute(), 'hashchange')
  })

  // 初始化路由跟踪
  const initialRoute = getRoute()
  routeTracker.lastRoute = initialRoute
  trackRoute(initialRoute)
}

initPv()
